import React from 'react';
import { CallToActionList } from './CallToActions';
import type { CallToActions, MediaProjectInstanceResponse } from '../types';

export interface CTAsProps {
  showSideCtas: boolean;
  callToActions: CallToActions | undefined;
  publication: MediaProjectInstanceResponse;
  locale: string;
  className?: string;
}

export const CTAs = React.memo(function CTAs({
  showSideCtas,
  callToActions,
  publication,
  locale,
  className = 'sidebar-ctas',
}: CTAsProps) {
  if (!showSideCtas || !callToActions) return null;
  return (
    <div className={className}>
      <CallToActionList
        callToActions={{
          actions: callToActions.actions.filter(
            (x: any) => x.action.type !== 'Download',
          ),
        }}
        publication={publication}
        locale={locale}
      />
    </div>
  );
});
